<template>
<!-- 2张图样式 -->
  <div
    id="twoPic"
    class="twoPic"
    v-bind:style="{backgroundImage:'url(' +'\''+ backgroundPic +'\''+ ')', backgroundRepeat:'no-repeat'}"
  >
    <div  class="left child-pic" 
    >
          <img @click="goLink(tbInfo.link1)" :src="tbInfo.image1"  class="pic" :class="tbInfo.link1?'link':''"/>
    </div>
    <div  class="right child-pic" 
    >
          <img @click="goLink(tbInfo.link2)" :src="tbInfo.image2"  class="pic" :class="tbInfo.link2?'link':''"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "twoPic",
  data() {
    return {
      loading: false
    };
  },
  props: ["tbInfo","backgroundPic"],
  methods: {
    // 跳转链接
    goLink(link){
      if(link){
         window.open(link)
      }
    }
  },
  computed: {
  },
  mounted() {
    
  }
};
</script>

<style scoped>
.twoPic {
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 100px 40px;
  box-sizing: border-box;
}
.twoPic .child-pic{
  flex:1;
  height: 100%;
  display: flex;
  justify-content: center;
}
.twoPic .child-pic img{
  padding: 10px;
  width: 465px;
  height: 330px;
  -o-object-fit: cover;
  object-fit: cover;
}

.twoPic .child-pic .link{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/tbChildPage/twoPic.vue